import type { Contact } from '@otw/models/leads/contacts';
import type { Task } from '@otw/models/tasks';
import type { LogContactActivityInput } from 'hooks/contacts/useContacts';

export interface TaskActivityPayload {
  contact_id: string;
  leadId?: string | null;
  title: string;
}

export function getContactForTask(
  contacts: Contact[],
  task: Pick<Task, 'contact_id'>,
): Contact | undefined {
  const id = task.contact_id?.trim();
  if (!id) return undefined;
  return contacts.find((c) => c.id === id);
}

/** True when a task belongs on a contact's detail page / preview. */
export function taskBelongsToContact(
  task: Pick<Task, 'contact_id'>,
  contact: Contact,
): boolean {
  return task.contact_id === contact.id;
}

/** Appends a `task` activity on the contact after a task is created. */
export async function logTaskCreationContactActivity(
  task: TaskActivityPayload,
  createdTaskId: string,
  logContactActivity: (input: LogContactActivityInput) => Promise<unknown>,
  domain: LogContactActivityInput['domain'] = 'sales',
): Promise<boolean> {
  const contactId = task.contact_id?.trim();
  if (!contactId) return false;

  await logContactActivity({
    contactId,
    type: 'task',
    note: task.title,
    taskId: createdTaskId,
    domain: domain === 'inventory' ? 'inventory' : 'sales',
    ...(task.leadId ? { leadId: task.leadId } : {}),
  });
  return true;
}
